import { number, object, ObjectSchema } from 'yup';

import { CoordinateValue } from '@client/api';

const schema: ObjectSchema<CoordinateValue> = object({
  longitude: number().required(),
  latitude: number().required(),
});

export { schema as coordinateValueSchema };
